// Utils
import { pathToRegexp } from 'path-to-regexp';
import { urlToList } from './pathTools';
import { RouterType, IMenuFunc } from '../type';

/**
 * @description Recursively flatten the data
 * [{path:string},{path:string}] => {path,path2}
 * @param menus
 */

export const getFlatMenuKeys = (menuData: RouterType[]) => {
    let keys: string[] = [];
    menuData.forEach((item: RouterType) => {
        keys.push(item.url);
        if (item.child) {
            keys = keys.concat(getFlatMenuKeys(item.child));
        }
    });
    return keys;
};

export const getFlatMenuFunc = (menuData: RouterType[], menuFunc: any = {}) => {
    menuData.forEach((item: RouterType) => {
        menuFunc[item.url] =
      item.functions && item.functions.length
      	? item.functions.map((func: IMenuFunc) => func.function_key)
      	: [];
        if (item.child_navigations) {
            getFlatMenuFunc(item.child_navigations, menuFunc);
        }
    });
    return menuFunc;
};

export const getMenuMatches = (flatMenuKeys: string[], path: string) =>
    flatMenuKeys.filter(item => {
        if (item) {
            return pathToRegexp(item).test(path);
        }
        return false;
    });

/**
 * @description 获得菜单子节点
 * @param props props
 * @memberof SiderMenu
 */
export const getDefaultCollapsedSubMenus = (props: any) => {
    const {
        location: { pathname },
        flatMenuKeys,
    } = props;
    return urlToList(pathname)
        .map(item => getMenuMatches(flatMenuKeys, item)[0])
        .filter(item => item)
        .reduce((acc, curr) => [...acc, curr], ['/']);
};
